import { DropDown, DropDownItem } from '@hulu-react-style-components/dropdown';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledDropDown = styled(DropDown)`
  background: ${({ theme }): string => theme.colors!.colorWhite};
  color: ${({ theme }): string => theme.admanColors!.gray.dark.bg3[0]};
  font-family: InspireTWDC;
  border-radius: 8px;
  min-width: 300px;

  &:hover {
    color: ${({ theme }): string => theme.admanColors!.gray.light.fg1[2]};
  }

  .TrekDropDownItem-label {
    background: inherit;
  }
`;

export const StyledDropDownGlobalStyle = createGlobalStyle`
  font-family: InspireTWDC;

  .TrekDropDown-popUpContainer {
    li:not(.TrekDropDownItem-root) {
      padding-left: ${({ theme: { spacers } }): string => spacers!.spacer04};

      span {
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: ${({ theme }): string => theme.admanColors!.gray.light.fg[2]};
      }
    }
  }

  .TrekDropDown-searchInput > svg {
    width: 16px;
  }

  .TrekDropDown-popUp:has(+ ul li.ad-account-item) {
    border-radius: 4px 4px 0 0;
    margin-top: 2px;
  }

  .TrekDropDown-popUp:has( li.ad-account-item) {
    border-radius: 0 0 4px 4px;
  }
`;

export const StyledDropDownItem = styled(DropDownItem)`
  font-family: InspireTWDC;
  line-height: 24px;
  padding: ${({ theme: { spacers } }): string => spacers!.spacer02} 0
    ${({ theme: { spacers } }): string => spacers!.spacer02} ${({ theme: { spacers } }): string => spacers!.spacer06};

  svg {
    margin: ${({ theme: { spacers } }): string => spacers!.spacer02}
      ${({ theme: { spacers } }): string => spacers!.spacer02} -${({ theme: { spacers } }): string =>
        spacers!.spacer01} -26px;
  }

  .TrekDropDownItem-subtext {
    margin: 0;
    position: absolute;
    left: ${({ theme: { spacers } }): string => spacers!.spacer07};
    top: ${({ theme: { spacers } }): string => spacers!.spacer01};
  }

  &::after {
    display: none;
    border-bottom: none;
  }
`;
